import React from 'react';
import { FiPlus, FiTrendingUp, FiCalendar, FiActivity } from 'react-icons/fi';
import './QuickActions.css';

const QuickActions = ({ onLogFood, onLogWeight, onViewMealPlan, onCalculateMacros }) => {
  const actions = [
    {
      id: 'log-food',
      label: 'Log Food',
      description: 'Track your meals',
      icon: FiPlus,
      color: 'orange',
      onClick: onLogFood
    },
    {
      id: 'log-weight',
      label: 'Log Weight',
      description: 'Update progress',
      icon: FiTrendingUp,
      color: 'green',
      onClick: onLogWeight
    },
    {
      id: 'meal-plan',
      label: 'View Meal Plan',
      description: 'See this week',
      icon: FiCalendar,
      color: 'blue',
      onClick: onViewMealPlan
    },
    {
      id: 'calculator',
      label: 'Calculate Macros',
      description: 'Get targets',
      icon: FiActivity,
      color: 'purple',
      onClick: onCalculateMacros
    }
  ];

  return (
    <div className="quick-actions-widget">
      <div className="widget-header">
        <h3>Quick Actions</h3>
      </div>

      <div className="actions-grid">
        {actions.map((action) => {
          const IconComponent = action.icon;
          return (
            <button
              key={action.id}
              className={`action-card ${action.color}`}
              onClick={action.onClick}
            >
              <div className="action-icon">
                <IconComponent />
              </div>
              <div className="action-info">
                <span className="action-label">{action.label}</span>
                <span className="action-description">{action.description}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;
